module.exports = __webpack_public_path__ + "static/media/usfb.262a20a5.svg";